import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { initLocale } from '@/stores/localeStore';

// Hydrate the locale store from localStorage/navigator so the language
// switcher reflects the active language. i18next's detector already sets the
// content language, but the zustand store would otherwise stay on its 'en'
// default, leaving the switcher stuck on "Eng".
initLocale();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
